// Shared reCAPTCHA step-up flow: when the invisible check fails, the backend returns
// `requires_captcha_challenge` and we render the visible checkbox as a fallback.
//
// Components using this mixin must have an `errorMessage` data property, send
// `recaptchaChallengeToken` in the checkout payload, call maybeHandleRecaptchaChallenge()
// first in their POST error handler, and include a `<div id="recaptcha-challenge">`.
export default {
    data() {
        return {
            recaptchaChallengeToken: null,
            recaptchaChallengeWidgetId: null,
            showRecaptchaChallenge: false,
        }
    },

    methods: {
        // Returns true when the response was a captcha step-up and has been handled.
        maybeHandleRecaptchaChallenge(response) {
            if (!_.get(response, 'body.requires_captcha_challenge')) {
                return false
            }

            let challengeKey = _.get(window, 'apr.google_recaptcha_challenge_site_key')

            // No checkbox key configured / reCAPTCHA unavailable - don't show an
            // empty box; give the customer something actionable instead.
            if (!challengeKey || typeof grecaptcha === 'undefined') {
                this.errorMessage = "We couldn't verify your browser. " +
                    "Please refresh the page and try again. " +
                    "Turning off a VPN, ad blocker, or private/incognito mode, or using a different browser, can help."

                return true
            }

            this.errorMessage = _.get(response, 'body.error.0')
                || _.get(response, 'body.errors.other.error.0')
                || "Please confirm you're human below to complete your booking."

            this.showRecaptchaChallenge = true
            this.$nextTick(() => this.renderRecaptchaChallenge())

            return true
        },

        renderRecaptchaChallenge() {
            let challengeKey = _.get(window, 'apr.google_recaptcha_challenge_site_key')
            let container = document.getElementById('recaptcha-challenge')

            if (!challengeKey || typeof grecaptcha === 'undefined' || !container) {
                return
            }

            // Already rendered once - reset so the customer gets a fresh token.
            if (this.recaptchaChallengeWidgetId !== null) {
                grecaptcha.enterprise.reset(this.recaptchaChallengeWidgetId)
                this.recaptchaChallengeToken = null
                return
            }

            let self = this
            grecaptcha.enterprise.ready(function () {
                self.recaptchaChallengeWidgetId = grecaptcha.enterprise.render(container, {
                    sitekey: challengeKey,
                    callback: function (token) {
                        self.onRecaptchaChallengeSolved(token)
                    },
                    'expired-callback': function () {
                        self.recaptchaChallengeToken = null
                    },
                })
            })
        },

        onRecaptchaChallengeSolved(token) {
            this.recaptchaChallengeToken = token
            this.errorMessage = null
        },
    },
}
